module.exports = __webpack_public_path__ + "img/2.9b3cf591.png";